const editorTheme = {
  paragraph: 'editor-paragraph',
  quote: 'editor-quote',
  heading: {
    h1: 'editor-heading-h1',
    h2: 'editor-heading-h2',
    h3: 'editor-heading-h3'
  },
  list: {
    ul: 'editor-list-ul',
    ol: 'editor-list-ol',
    listitem: 'editor-listitem'
  },
  link: 'editor-link',
  hashtag: 'editor-hashtag',
  mark: 'editor-mark',
  markOverlap: 'editor-mark-overlap',
  text: {
    bold: 'editor-text-bold',
    italic: 'editor-text-italic',
    underline: 'editor-text-underline',
    strikethrough: 'editor-text-strikethrough',
    subscript: 'editor-text-subscript',
    superscript: 'editor-text-superscript',
    code: 'editor-text-inline-code'
  },
  code: 'editor-code-block',
  codeHighlight: {
    atrule: 'editor-token-attr',
    attr: 'editor-token-attr',
    boolean: 'editor-token-property',
    builtin: 'editor-token-selector',
    cdata: 'editor-token-comment',
    char: 'editor-token-selector',
    class: 'editor-token-function',
    'class-name': 'editor-token-function',
    comment: 'editor-token-comment',
    constant: 'editor-token-property',
    deleted: 'editor-token-property',
    doctype: 'editor-token-comment',
    entity: 'editor-token-operator',
    function: 'editor-token-function',
    important: 'editor-token-variable',
    inserted: 'editor-token-selector',
    keyword: 'editor-token-attr',
    namespace: 'editor-token-variable',
    number: 'editor-token-property',
    operator: 'editor-token-operator',
    prolog: 'editor-token-comment',
    property: 'editor-token-property',
    punctuation: 'editor-token-punctuation',
    regex: 'editor-token-variable',
    selector: 'editor-token-selector',
    string: 'editor-token-selector',
    symbol: 'editor-token-property',
    tag: 'editor-token-property',
    url: 'editor-token-operator',
    variable: 'editor-token-variable'
  },
  table: 'editor-table',
  tableRow: 'editor-table-row',
  tableCell: 'editor-table-cell',
  tableCellHeader: 'editor-table-cell-header'
};

export default editorTheme;
